import ViewResourceDetailsForm from "../../features/CorporateResource/ViewResourceDetailsForm";

const ViewResourceDetails = () => {
  return (
    <div>
      <ViewResourceDetailsForm />
    </div>
  );
};
export default ViewResourceDetails;
